import { Validator } from '@vista-digital/validator';
import { defaultFilmWatchlistButtonConfig, filmWatchlistButtonConfigValidator } from './config';
import { filmWatchlistButtonEventsValidator } from './events';
export const defaultFilmWatchlistButtonProps = {
    config: defaultFilmWatchlistButtonConfig,
    events: {}
};
export const filmWatchlistButtonPropsValidator = Validator.object({
    config: filmWatchlistButtonConfigValidator,
    events: filmWatchlistButtonEventsValidator
});
//# sourceMappingURL=props.js.map